import { requestAndParse, requestSuccessful } from '../request';

const setPassword = async (newPassword: string, currentPassword: string) => {
    const route = 'auth/set-password';
    const payload = {
        currentPassword,
        password: newPassword,
    };

    const response = await requestAndParse(route, payload, 'POST');

    return {
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default setPassword;
